module.exports = __webpack_public_path__ + "static/media/attack-doubled.0df831b8.png";